import { render, staticRenderFns } from "./BuildingsAndRooms.vue?vue&type=template&id=1f91f5fb&"
import script from "./BuildingsAndRooms.vue?vue&type=script&lang=js&"
export * from "./BuildingsAndRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports